
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"108","height":"108","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".92"}},[_c('path',{attrs:{"d":"M59.041 17h-9.977L8 83.06l6.617 8.506h78.767L100 83.06 59.041 17zM17.242 83.48L54 22.88 90.758 83.48H17.242z","fill":"#fff"}}),_c('path',{attrs:{"d":"M51 52.343l.945 14.178h4.516l.945-14.178V41H51v11.343zM53.78 70C51.576 70 50 71.47 50 73.886c0 2.415 1.575 3.78 3.78 3.78 2.206 0 3.782-1.47 3.782-3.78 0-2.31-1.47-3.886-3.781-3.886z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.242 83.48L54 22.88 90.758 83.48H17.242zm-2.626 8.086h78.768L100 83.06 59.041 17h-9.977L8 83.06l6.617 8.506z","fill":"#0037FF"}}),_c('path',{attrs:{"d":"M51.945 66.52h4.516l.945-14.177V41H51v11.343l.945 14.178zM53.78 77.667c2.311 0 3.782-1.47 3.782-3.781 0-2.31-1.47-3.886-3.781-3.886C51.47 70 50 71.47 50 73.886c0 2.415 1.575 3.78 3.78 3.78z","fill":"#FF4F33"}})])])
          )
        }
      }
    